module.exports = {"dropDownPlaceholder":"Sign in Without Adobe Id"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/en_us.json
// module id = 927
// module chunks = 0